import React, {useState} from 'react';
import {Liquid} from "@ant-design/plots";
import {Button, Modal} from "antd";

const LiquidChart = (props) => {
    const configLiquid  = {
        percent: props?.data?.loaded_percentage / 100,
        outline: {
            border: 2,
            distance: 2,
            style: {
                stroke: '#5664D2',
                strokeOpacity: 0.85,
            },
        },
        wave: {
            length: 128,
        },
        theme: {
            styleSheet: {
                brandColor: '#5664D2',
            },
        },
    };

    return (
        <div className="col-md-6"> <div className="work-time-box-item mb-3 d-flex justify-content-between">
            <div className="d-flex">
                <div className="emp-img">
                    <img src={props?.data?.image} alt="..."/>
                </div>
                <div className="work-time-box-item-content">
                    <p>{props?.data?.employee}</p>
                    <p>{props?.data?.department}</p>
                    <p>{props?.data?.branch + " " } <span className="text-success">{ props?.data?.position}</span></p>
                </div>
            </div>
            <div className="Liquid-style d-flex">
                <Liquid {...configLiquid} />
                <div className="ml-8">
                    <button onClick={() => props?.getGraph(props?.data?.employee_id)}><img src="/icon/eye.svg" alt=""/></button>
                </div>
            </div>
            </div>

        </div>
    );
};

export default LiquidChart;